import { Fragment } from 'react'
import { DownloadContent } from './Download'

interface IDownloadTabProps {
  activeTab?: string
}

const DownloadTab = ({ activeTab }: IDownloadTabProps) => {
  // TODO: Add loading state when Redux is integrated
  // const getDownloadActionLoading = useAppSelector(
  //   (state) =>
  //     state.evolveLanding.loadings[thunkActionLoading.GET_DOWNLOAD_LOADING]
  // )

  return (
    <Fragment>
      <div className="bg-white p-5 pt-[60px]">
        <div>
          <>
            <DownloadContent activeTab={activeTab} />
          </>
        </div>
      </div>
    </Fragment>
  )
}

export default DownloadTab
